import { INVOICE_SCHEMA, BUSINESS_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";
import { database } from "../index";

const invoice = database.collections.get(INVOICE_SCHEMA);


export const fetchSaleInvoicesCount = () =>
  invoice
    .query(Q.where("tranType", "bill"), Q.where("type", "in"))
    .fetchCount();
export const fetchBillInvoicesCount = () =>
  invoice
    .query(Q.where("tranType", "bill"), Q.where("type", Q.notEq("in")))
    .fetchCount();
export const fetchExpenseCount = () =>
  invoice
    .query(Q.where("tranType", Q.notEq("bill")), Q.where("type", "out"))
    .fetchCount();
export const fetchQuickSaleCount = () =>
  invoice
    .query(Q.where("tranType", Q.notIn(["bill", "pos"])), Q.where("type", "in"))
    .fetchCount();

export const observeSaleInvoicesByBusiness = (businessId) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("type", "in"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observe();

export const observeSaleInvoicesByBusinessCount = (businessId) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("type", "in"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observeCount();

export const observePurchaseBillByBusiness = (businessId) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("type", "out"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observe();

export const observePurchaseBillByBusinessCount = (businessId) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("type", "out"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observeCount();

export const observeExpenseByBusiness = (businessId) =>
  invoice
    .query(
      Q.where("tranType", Q.notEq("bill")),
      Q.where("type", "out"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observe();

export const observeExpenseByBusinessCount = (businessId) =>
  invoice
    .query(
      Q.where("tranType", Q.notEq("bill")),
      Q.where("type", "out"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observeCount();

export const observeQuickSaleByBusiness = (businessId) =>
  invoice
    .query(
      Q.where("tranType", Q.notIn(["bill", "pos"])),
      Q.where("type", "in"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observe();

export const observeQuickSaleByBusinessCount = (businessId) =>
  invoice
    .query(
      Q.where("tranType", Q.notIn(["bill", "pos"])),
      Q.where("type", "in"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observeCount();


export const observePOSByBusinessCount = (businessId) =>
  invoice
    .query(
      Q.where("tranType", "pos"),
      Q.where("type", "in"),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observeCount();

export const BusinessOverviewTransactionsCount = (businessId) =>
  invoice.query(Q.on(BUSINESS_SCHEMA, "id", businessId)).observeCount();

export const observeAllSaleByBusinessCount = (businessId) =>
  invoice
    .query(Q.where("type", "in"), Q.on(BUSINESS_SCHEMA, "id", businessId))
    .observeCount();

export const observeAllExpensesByBusinessCount = (businessId) =>
  invoice
    .query(Q.where("type", "out"), Q.on(BUSINESS_SCHEMA, "id", businessId))
    .observeCount();

export const getSignatureToSyncCB = async () =>
  await invoice.query(Q.where("signature", Q.like("%data:image%"))).fetch();

export const getImagesToSyncCB = async () =>
  await invoice.query(Q.where("image_url", Q.like("%data:image%"))).fetch();

export const getInvoicesByBusiness = async (id) =>
  await invoice.query(Q.on(BUSINESS_SCHEMA, "id", id)).fetch();

export const getCashCount = async () =>
  await invoice.query(Q.where("tranType", Q.notEq("bill"))).fetchCount();

export const getInvoicesByCustomer = async (id) =>
  await invoice.query(Q.where("customer_id", id)).fetch();

export const getInvoiceCount = async () =>
  await invoice.query(Q.where("tranType", "bill")).fetchCount();

export const observeCurrentInvoice = (id) =>
  invoice
    .query(Q.where("tranType", "bill"), Q.where("id", id))
    .observeWithColumns(["advance_amount"]);
export const observeCurrentInvoiceByInvNum = (invPre, invNum, business_id) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("invoice_number", invNum),
      Q.where("invoice_prefix", `${invPre}#`),
      Q.where("business_id", business_id),
    )
    .observeWithColumns(["advance_amount"]);

export const observeInvoicesById = (id) =>
  invoice.query(Q.where("id", id)).observe();

export const getInvoiceByID = async (id) => await invoice.find(id);


export const observeMainInvoicesById = (id) =>
  invoice.query(Q.where("id", id),Q.where("tranType" , "bill")).observe();


export const observeActiveCash = (id) =>
  invoice
    .query(
      Q.where("tranType", Q.notEq("bill")),
      Q.where("business_id", id),
      Q.on(BUSINESS_SCHEMA, [Q.where("is_active", true)]),
    )
    .observe();

export const observeActiveInvoice = (id) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("business_id", id),
      Q.on(BUSINESS_SCHEMA, [Q.where("is_active", true)]),
    )
    .observe();

export const getInvoiceOfBusiness = (business_id) =>
  invoice
    .query(
      Q.where("tranType", Q.notEq("bill")),
      Q.where("business_id", business_id),
    )
    .observe();

export const getBillOfBusiness = (business_id) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("business_id", business_id),
      Q.where("tranType", "bill"),
    )
    .observe();

export const observeSaleInvoiceCount = (business) => {
  return invoice
    .query(
      Q.and(Q.where("tranType", "bill"), Q.where("type", "in")),
      Q.on(BUSINESS_SCHEMA, [
        Q.where("id", business?.id),
        Q.where("is_active", true),
      ]),
    )
    .observeCount();
};

export const observeBillInvoiceCount = (business) =>
  invoice
    .query(
      Q.and(Q.where("tranType", "bill"), Q.where("type", Q.notEq("in"))),
      Q.on(BUSINESS_SCHEMA, [
        Q.where("id", business?.id),
        Q.where("is_active", true),
      ]),
    )
    .observeCount();

export const observeBillInvoicesByBusiness = (businessId) =>
  invoice
    .query(
      Q.where("tranType", "bill"),
      Q.where("type", Q.notEq("in")),
      Q.on(BUSINESS_SCHEMA, "id", businessId),
    )
    .observe();

export const removeCustomerFromInvoices = async (allInvoices) => {
  if (allInvoices?.length) {
    await database.write(async () => {
      const allRecords = await prepareUpdation(allInvoices);
      await database.batch(...allRecords);
    });
  }
};

export const batchDeleteInvoices = async (allInvoices) => {
  await database.write(async () => {
    const allRecords = await prepareDeletion(allInvoices);
    await database.batch(...allRecords);
  });
};

const prepareUpdation = async (allInvoices) => {
  return await Promise.all(
    allInvoices.map(async (invoice) => {
      try {
        return invoice.prepareUpdate((inv) => {
          inv.customer.set("");
        });
      } catch (err) {
      }
    }),
  );
};

const prepareDeletion = async (allInvoices) => {
  return await Promise.all(
    allInvoices.map(async (invoice) => {
      try {
        return invoice.prepareMarkAsDeleted();
      } catch (err) {
      }
    }),
  );
};

export const bulkDeleteInvoicesByBusiness = async (business_id) => {
  await database.write(async () => {
    let invoices = await getInvoicesByBusiness(business_id);
    const allRecords = await prepareDeletion(invoices);
    await database.batch(...allRecords);
  });
};

export const getAttachmentsToSync = async () => {
  try {
    let records = await invoice
      .query(Q.where("attachment", Q.notLike("[]")))
      .fetch();
    if (records?.length) {
      const filteredRecords = records.filter((record) => {
        const attachments = record.attachment || [];
        return attachments.some((attachment) =>
          attachment?.file?.startsWith?.("data"),
        );
      });
      return filteredRecords;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching records:", error);
  }
};
